import { handleProductByUrl } from "./handleProductByUrl";

// Esta funcion gestiona el cambio de producto con la funcion handleProductByUrl(), la cual es invocada
//dependiendo de algunos parametros.
export function gestionarEmpresas() {

    const url = location.href;
    const empresa = url.includes("/empresas/");
    const autonomos = url.includes("/autonomos/");
    const exceptions = url.includes("https://www.mapfre.es/particulares/seguros-para-comunidades-propietarios/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-proteccion-alquileres/") ||
        url.includes("https://www.mapfre.es/particulares/seguro-propietarios-edificios-viviendas/") ||
        url.includes("https://www.mapfre.es/particulares/renting-coches/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-vida/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-vida/seguro-amortizacion-hipoteca/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-vida/seguro-de-dependencia/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-vida/familiar-familife/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-vida/vida-riesgo-v80/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-vida/capital-temporal-fijo/ ") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-accidentes/pmr-conductor/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-accidentes/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-embarcaciones/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-bicicletas/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-para-motos/") ||
        url.includes("https://www.mapfre.es/particulares/seguro-para-moto-clasica/") ||
        url.includes("https://www.mapfre.es/particulares/patinete-electrico/") ||
        url.includes("https://www.mapfre.es/ahorro-inversion/ahorro/seguro-ahorro-garantizado/") ||
        url.includes("https://www.mapfre.es/ahorro-inversion/inversion/quiero-empezar-a-invertir/") ||
        url.includes("https://www.mapfre.es/ahorro-inversion/ahorro/") ||
        url.includes("https://www.mapfre.es/ahorro-inversion/ahorro/seguros-pias/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-decesos/") ||
        url.includes("https://www.mapfre.es/ahorro-inversion/planes-de-pensiones/") ||
        url.includes("https://wmapfrees.pre.mapfre.net/ahorro-inversion/") || /** URL test */
        url.includes("https://www.mapfre.es/ahorro-inversion/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-dentales/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-salud/") ||
        url.includes("https://www.mapfre.es/particulares/seguros-de-hogar/") ||
        url.includes("https://eurasiabk.mapfre.com/mapfrees/particulares/seguros-para-motos/poliza-temporal/") || /** URL test */
        url.includes("https://www.mapfre.es/particulares/seguros-para-motos/poliza-temporal/") ||
        url.includes("https://eurasiabk.mapfre.com/mapfrees/tu-te-vienes/") || /** URL test */
        url.includes("https://www.mapfre.es/tu-te-vienes/")
        ;

    const intervalActiveDigital = setInterval(() => {
        if (typeof window.userLabels === 'object' && typeof window.userLabels.EExternals === 'object') {
            clearInterval(intervalActiveDigital);
            window.userLabels.EExternals.push({ id: 2189, option: 5, comments: 'Portal MAPFRE' });
        }
    }, 300);

    if (empresa || autonomos || exceptions) {

        handleProductByUrl()
            .then((response) => {
                try {
                    var conversionsValues = conversionsValues ? conversionsValues : []
                    conversionsValues.push({ id: "4", value: response });
                } catch (error) {
                    console.error(error);
                }
                womtp.c_vars[4] = response;
                window.c_var_4 = response;
                // window.userLabels.EConversion.push({id:4,value:response});
            })
            .catch((error) => {
                console.error(error);
            });

    }
}